import {Component, OnInit} from '@angular/core';
import {Card, Condition, Edition, Language, PriceRule, ProductDetail, Warehouse} from '../../core/entities/entities';
import {LanguageService} from '../../services/language.service';
import {WarehouseService} from '../../services/warehouse.service';
import {ToastrService} from 'ngx-toastr';
import {ComponentBase} from '../../core/entities/component-base';
import {CardConditionService} from '../../services/card-condition.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/zip';
import {ActivatedRoute, Router} from '@angular/router';
import {PriceRuleService} from '../../services/price-rule.service';
import {CardQuery, CardService} from '../../services/card.service';
import * as Rx from 'rxjs/Rx';
import {TypeaheadMatch} from 'ngx-bootstrap';
import {EditionService, EditiontQuery} from '../../services/edition.service';
import {Page} from '../../core/services/HttpServiceBase';

interface PriceRuleFilter {
  brandId?: any;
  categoryId?: any;
  signed?: boolean;
  stamped?: boolean;
  inked?: boolean;
  altered?: boolean;
  conditionId?: number;
  cardId?: any;
  product?: ProductDetail;
  holoId?: number;
  languageId?: any;
  rarityId?: number;
  editionName?: string;
  editionId?: any;
  warehouseId?: any;
  firstEdition?: boolean;
  foil?: boolean;
  warehouse?: Warehouse;
  language?: Language;
  condition?: Condition
  rarity?: {id:any, name:string};
  expansion?: {
    id: any,
    enName: string;
  };

  productName?: string;
  languageSearchId?: any;
}

@Component({
  selector: 'app-price-rule',
  templateUrl: './price-rule.component.html',
  styleUrls: ['./price-rule.component.css']
})
export class PriceRuleComponent extends ComponentBase implements OnInit {
  isCommentDisabled: boolean = true;
  ruleMinMax: string[] = [ 'minRule', 'maxRule'];

  card_search: CardQuery = {autocomplete_edition: '', autocomplete_card_name: '', autocomplete_language: this.defaultLanguageId};
  cards: Observable<Card[]>;
  card: Card;

  columns=[
    {label:'name', order:'productRel.enName'},
    {label:'expansion', order:'expansionRel.enName'},
    {label:'Modified Date', order:'modifiedDate'},
    {label:'Modified By', order:'modifiedBy'},
    // {label:'warehouse', order:'warehouse.name'},
    {label:'language', order: null}, //'language.cardLanguage'},
    {label:'rarity', order: null}, // 'product.rarity'},
    {label:'condition', order: null}, //'condition.condition'},
    {label:'holo', order: 'combination.holo.id'}, //'condition.condition'},
    //{label:'hot', order:'hot'},

    {label:'foil', order:'combination.foil'},
    {label:'firstEdition', order:'combination.firstEdition'},
    {label:'signed', order:'combination.signed'},
    {label:'stamped', order:'combination.stamped'},
    {label:'inked', order:'combination.inked'},
    {label:'altered', order:'combination.altered'},
    {label:'shadowless', order:'combination.shadowless'},
    {label:'staff', order:'combination.staff'},
    {label:'minRule', order:'minRule'},
    {label:'maxRule', order:'maxRule'},
    {label:'price', order:'price'},
  ];

  private _page: Page<PriceRule>;

  getName(){
    return 'PriceRuleComponent';
  }

  setOrder(field: string){
    this._priceRuleService.setOrder(this.page, field);
    this.setPageIndex(1);
  }

  getOrder(field: string){
    return this._priceRuleService.getOrder(this.page, field);
  }

  get page(): Page<PriceRule> {
    return this._page
  }

  get pageIndex() {
    return this.page ? this.page.number +1 : 1;
  }

  set pageIndex(num: number) {
    if(this.pageIndex == num) return;
    this.setPageIndex(num);
  }

  private setPageIndex(num: number){
    this.spinnerService.show();
    this._priceRuleService.toPage(this.page, num-1).subscribe(ret => { this._page = ret; this.saveStorage('page',ret); this.spinnerService.hide();});
  }

  isCommentEnabled(){
    this.isCommentDisabled = !this.isCommentDisabled;
  }

  selectCard(event: TypeaheadMatch) {
    if (event && event.item) {
      this.card = event.item;
      this.card_search.autocomplete_card_name = this.card.name;
      this.card_search.autocomplete_edition = this.card.edition;
      this.filters.cardId = this.card.id;
    }
  }

  eraseCard() {
    this.card_search.autocomplete_edition = '';
    this.filters.cardId = null;
    this.card = null;

    this.saveStorage('card', this.card);
  }

  selectEdition(event: TypeaheadMatch) {
    if ( event && event.item ) {
      this.edition = event.item;
      this.edition_search.edition_name =  this.edition.name;
      this.filters.editionId = this.edition.id;
    }
  }

  eraseEdition() {
    this.edition_search.edition = null;
    this.filters.editionId = null;
    this.edition =null;
    this.saveStorage('edition', this.edition);
  }

  private hasCheck: boolean;
  private allCheckStatus: boolean;

  get hasSelection() : boolean {
    return this.hasCheck;
  }
  allcheckStatus(){
    var me = this;
    return {
      get checked(){
        return me.allCheckStatus;
      },
      set checked(val: boolean){
        me.checkAll(val);
      }
    }
  }

  checkAll(val : boolean){
    this.allCheckStatus = val;
    this.saveCheckStatus(this._page.content, val);

  }

  saveCheckStatus(data: PriceRule[], val: boolean) {
    if(data){
          data.forEach(od => od.selected = val);
    }
    this.loadAllCheckStatus();

  }

  private loadAllCheckStatus(){
    this.hasCheck =  this._page.content != null && this._page.content.length > 0 && this._page.content.some( od => od.selected);
    this.allCheckStatus =  this._page.content.every( od => od.selected);
  }

  checkStatus(od: PriceRule){
    var me = this;
    return {
      get checked(){
        return od.selected;
      },
      set checked(val: boolean){
        od.selected = val;
        me.loadAllCheckStatus();
      }
    }
  }

  edition_search: EditiontQuery = {edition_name:'', type: 0, wh_id: null};
  editions: Rx.Observable<Edition[]>;
  edition: Edition;

  get prices(): Observable<PriceRule[]>{
    return this._priceRuleService.dataChange;
  }

  get warehouses() {
    return Observable.create((observer: any) => {
      this._warehouseService.dataChange.subscribe(ret => observer.next(ret.filter(w => !w.refill)));
    });
  };

  get languages() {
    return this._languageService.dataChange;
  };

  get conditions() {
    return this._cardConditionService.dataChange;
  };

  defaultFilters: PriceRuleFilter =  { languageSearchId : this.constants.defaultLanguageId};

  filters: PriceRuleFilter = Object.assign({}, this.defaultFilters, this.getStorage('filters'));

  constructor(private _priceRuleService: PriceRuleService,
              private _route: ActivatedRoute,
              private _languageService: LanguageService,
              private _warehouseService: WarehouseService,
              private _cardConditionService: CardConditionService,
              private _cardService: CardService,
              private _editionServ: EditionService,
              private _router: Router,
              private _toastrService: ToastrService) {
    super();
  }

  ngOnInit() {
    const me = this;
    this.spinnerService.show();



    this.cards = Rx.Observable.create((observer: any) => {
      observer.next(this.card_search);
    }).debounceTime(150)
      .distinctUntilChanged()
      .switchMap((term) => {
      return this._cardService.search({...term, categoryId: this.categoryId, brandId: this.brandId});
    });

    this.editions = Rx.Observable.create((observer: any) => {
      observer.next(this.edition_search);
    }).debounceTime(150)
      .distinctUntilChanged()
      .switchMap((term) => {
      return this._editionServ.search({...term, brandId: this.brandId });
    });

    this.filters = Object.assign({}, this.defaultFilters, this.getStorage('filters'));
    this.productStructureChange.subscribe( () => this.prepareFilters());

    let card = this.getStorage('card');
    if(card )
      this.selectCard(new TypeaheadMatch(Object.assign(new Card(), card)));

    let edition = this.getStorage('edition');
    if(edition )
      this.selectEdition(new TypeaheadMatch(Object.assign(new Edition(), edition)));


    let page =  this.getStorage('page');
    if(page){
      this._page= page;
      me.setPageIndex(me.pageIndex);
    }else {
      me.applyFilters();
    }
  }

  removeAll(){
    const me = this;
    const obsList = this._page.content.filter( pr => pr.selected).map( pr =>  me._priceRuleService.remove( pr));
    if(obsList.length > 0) {
      this.spinnerService.show();
    }
    Observable.zip(...obsList).subscribe( ret =>
    {
      me._toastrService.success('Eseguito Correttamente!');
      me.applyFilters();
      me.allcheckStatus().checked = false;

    });
  }

  clearFilters() {
    this.eraseCard();
    this.eraseEdition();
    this.filters = Object.assign({}, this.defaultFilters);
    this.saveStorage('filters', this.filters);
    this.edition_search.edition = null;
    this.edition_search.edition_name = null;
    this.card_search.autocomplete_card_name = '';
  }

  prepareFilters(): PriceRuleFilter {
    const ret = Object.assign({}, this.filters);



    if(ret.cardId){
      ret.productName = null;
      ret.languageSearchId = null;
    } else if( this.card_search.autocomplete_card_name && this.card_search.autocomplete_card_name.length > 0) {
      ret.productName = this.card_search.autocomplete_card_name;
      ret.languageSearchId = this.card_search.autocomplete_language;
    } else {
      ret.productName = null;
      ret.languageSearchId = null;
    }

    if (!this.isEnabledStructure('language')) ret.languageId = null;
    if (!this.isEnabledStructure('condition')) ret.conditionId = null;
    if (!this.isEnabledStructure('rarity')) ret.rarity = null;
    if (!this.isEnabledStructure('expansion')) ret.editionId = null;
    if (!this.isEnabledStructure('holo')) ret.holoId = null;
    if (!this.isEnabledStructure('altered')) ret.altered = null;
    if (!this.isEnabledStructure('foil')) ret.foil = null;
    if (!this.isEnabledStructure('signed')) ret.signed = null;
    if (!this.isEnabledStructure('stamped')) ret.stamped = null;
    if (!this.isEnabledStructure('firstEdition')) ret.firstEdition = null;
    if (!this.isEnabledStructure('inked')) ret.inked = null;

    ret.brandId = this.brandId;
    ret.categoryId = this.categoryId;
    this.saveStorage('filters', ret);
    this.saveStorage('card', this.card);
    this.saveStorage('edition', this.edition);
    return ret;
  }

  applyFilters() {
    this._page = null;
    this._priceRuleService.search(this.prepareFilters()).subscribe(ret => { this._page = ret; this.saveStorage('page', ret);  this.spinnerService.hide(); });
  }

  detail(p: PriceRule){
    console.log('price URLES',p);
    // this.spinnerService.show();


    this._router.navigateByUrl('/home/price_rule/'  + (p as any).brand.id + '/' + (p as any).category.id + '/' + p.id);



  }

  add() {
    this.spinnerService.show();
    this._router.navigateByUrl('/home/price_rule_add');
  }

  addSet() {
    this.spinnerService.show();
    this._router.navigateByUrl('/home/price_rule_set_add');
  }



}



// WEBPACK FOOTER //
// ./src/app/conf/price-rule/price-rule.component.ts